module.exports = __webpack_public_path__ + "static/media/fac10.fa27ef5a.jpg";